import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import Button from '../../../Navigation/components/Button';
import { useMultiStepFormContext } from '../../../components/MultiStepPage/MultiStepPage';
export const FormController = ({ className, prevStepText, nextStepText, onPrev, onNext, }) => {
    const { prevStep, nextStep, currentStep, nextStepLocked } = useMultiStepFormContext();
    const { prevTxt, nextTxt } = useMemo(() => ({
        prevTxt: Array.isArray(prevStepText) ? prevTxt[currentStep] : prevStepText,
        nextTxt: Array.isArray(nextStepText) ? nextStepText[currentStep] : nextStepText,
    }), [currentStep]);
    const handlePrev = () => (onPrev ? onPrev(currentStep) : prevStep());
    const handleNext = () => (onNext ? onNext(currentStep, nextStep) : nextStep());
    return (_jsxs("div", { className: className, children: [_jsx(Button, { className: 'cancel', variant: 'tertiary', size: 'md', onClick: handlePrev, children: prevTxt }), _jsx(Button, { disabled: nextStepLocked, className: 'next', variant: 'secondary', size: 'md', onClick: handleNext, children: nextTxt })] }));
};
